<div>
    <div class="modal-header">
        <div class="modal-title" *ngIf="modalMode === 'add'">
            <h4>Create Activity Pack status</h4>
        </div>
        <div class="modal-title" *ngIf="modalMode === 'edit'">
            <h4>Edit Activity Pack status</h4>
        </div>
        <a class="close-icon" href="javascript:void()"><i class="flaticon2-cross" (click)="closeModalWithCancel()"></i></a>
    </div>
    <div class="modal-body output-lable">
        <form [formGroup]="activityStatusForm">
            <div class="row">
                <div class="col-md-3" style="padding: 15px 0 15px 24px">
                    <mat-label>Name:</mat-label>
                </div>
                <div class="col-md-9">
                    <mat-form-field class="example-full-width">
                        <input type="text" formControlName="status_name" placeholder="Name" matInput name="Name" />
                    </mat-form-field>
                </div>
            </div>
            <div class="row">
                <div class="col-md-3" style="padding: 15px 0 15px 24px">
                    <mat-label>Status Type:</mat-label>
                </div>
                <div class="col-md-9">
                    <mat-select name="status" class="lubricant-select" formControlName="status_type" [(value)]="statusTypeOptionToBeSelected">
                        <mat-option [value]="option.activityPackTypeStatusTypeId" *ngFor="let option of activityStatusTypes">{{ option.name }}</mat-option>
                    </mat-select>
                </div>
            </div>
            <div class="row">
                <div class="col-md-3" style="padding: 15px 0 15px 24px">
                    <mat-label>Color:</mat-label>
                </div>
                <div class="col-md-9 pt-3">
                    <span class="color_box" [style.background]="colorDefault" [cpPosition]="'auto'" [(colorPicker)]="colorDefault"></span>
                </div>
            </div>
        </form>
    </div>
    <div class="modal-footer">
        <button type="button" class="btn primary-ebtn" (click)="closeModalWithResult()" [disabled]="!activityStatusForm.valid">Save</button>
        <button type="button" class="btn secondary-ebtn" (click)="closeModalWithCancel()">Cancel</button>
    </div>
</div>
